const negEvalsOnly = (evaluations) =>
	(!evaluations ? [] : Array.isArray(evaluations) ? evaluations : Object.values(evaluations)).filter(
		(evaluation) => evaluation.result !== 'PASS'
	);

export default negEvalsOnly;
